// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/sidebar/sidebar.less
// module id = 3162
// module chunks = 0